import {ModalType} from "../../../../types/common";
import modalStyle from "../../../../assets/scss/common/modal/modal.module.scss";
import style from "./externalVoucherModal.module.scss";
import giftImage from "../../../../assets/images/mypage/voucher_gift_image.svg"
import {Modal} from "../Modal";
import {useAppDispatch, useLanguage, useModal, useUserAgent} from "../../../../hooks/hooks";
import {useCallback, useState} from "react";
import {CodeInput} from "./CodeInput";
import {registerExternalVoucherAsync} from "../../../../store/voucher/voucherSlice";
import {RegisterVoucherDTO} from "../../../../types/voucher";
import {Trans, useTranslation} from "react-i18next";

export function ExternalVoucherRegister() {
    const { t } = useTranslation("topBanner");
    const {showModal, closeModal, openAlertModal} = useModal();
    const dispatch = useAppDispatch();
    const { isKorean } = useLanguage();
    const [codeValues, setCodeValues] = useState<string[]>(Array(8).fill(''));
    const [activeBox, setActiveBox] = useState<number | null>(null);
    const [errorText, setErrorText] = useState("")
    const onClickCloseBtn = () => closeModal();
    const {isMobile} = useUserAgent();
    const registerText = isMobile
        ? <><Trans t={t} i18nKey={"topBanner.btn.externalCode.detail2"} components={{br: <br />}}/>
            <br />{t('topBanner.btn.externalCode.subDetail')}</>
        : <>{t('topBanner.btn.externalCode.detail1')}<br />{t('topBanner.btn.externalCode.subDetail')}</>;


    const onClickRegisterButton = () => {
        const data = codeValues.join('')

        const hasEmptyValue = codeValues.some(value => value === '');
        const hasForbiddenWord = codeValues.some(
            value => value === 'I' || value === 'L' || value === 'O' || value === '0'
        );

        if (hasEmptyValue) {
            setErrorText(t('topBanner.btn.externalCode.warning.eightLength'))
            return;
        }

        if (hasForbiddenWord) {
            setErrorText(t('topBanner.btn.externalCode.warning.doubleCheck'))
            return;
        }

        registerVoucher(data).then((result) => {
            if (result) {
                openAlertModal({
                    title: t('topBanner.btn.externalCode.info.title'),
                    desc: t('topBanner.btn.externalCode.info.success'),
                    callback: () => {
                        closeModal()
                        window.location.reload();
                    }
                });

            }
        });
    }

    const registerVoucher = useCallback(
        async (voucherCode: string) => {
            const dto: RegisterVoucherDTO = {voucherCode}
            try {
                await dispatch(registerExternalVoucherAsync(dto)).unwrap();
                return true;

            } catch (error: any) {
                // JSON 파싱
                const parsedError = JSON.parse(error.message);

                if (parsedError.errorCode.httpCode === 400) {
                    setErrorText(t('topBanner.btn.externalCode.warning.alreadyUse'))
                }

                if (parsedError.errorCode.httpCode === 404) {
                    setErrorText(t('topBanner.btn.externalCode.warning.doubleCheck'))
                }
                console.log(error);
                return false;
            }
        },
        [dispatch, t]
    );

    return (
        <Modal
            showModal={showModal.valueOf() === ModalType.EXTERNAL_VOUCHER.valueOf()}
            title={t('topBanner.btn.externalCode.label')}
            closeModalFunction={onClickCloseBtn}
            modalBgStyle={modalStyle.mainColorBg}
            modalCloseButtonStyle={modalStyle.mainColorBg}
        >
            <div className={`${style.body} ${isKorean ? "" : style.en}`}>
                <div className={style.contents}>
                    <img className={style.giftImage} src={giftImage} alt={"giftImage"}/>
                    <div className={style.registerArea}>
                        <span className={style.text}>
                            {registerText}
                        </span>

                        <CodeInput onSubmit={onClickRegisterButton}
                                   errorText={errorText} setErrorText={setErrorText}
                                   activeBox={activeBox} setActiveBox={setActiveBox}
                                   codeValues={codeValues} setCodeValues={setCodeValues}
                        />

                        <div className={style.buttonsWrapper} onClick={onClickRegisterButton}>
                            <span className={style.text}>
                                {t('topBanner.btn.externalCode.register')}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    )
}